// extracted by mini-css-extract-plugin
export default {"customer-invoice":"customerinvoice_customer-invoice__vTFO5","title":"customerinvoice_title__KQ5YH","no":"customerinvoice_no__4fAqh","del":"customerinvoice_del__KnZFa"};